module services {
    export module compliance {
        export class consignmentTemplateService implements interfaces.compliance.IConsignmentTemplateService {
            static $inject = ["$resource", "ENV", "$http", "generalService", "$timeout"];
            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig,
                private $http: ng.IHttpService, public generalService: interfaces.applicationcore.IGeneralService,
                private $timeout: ng.ITimeoutService) {
            }

            getComplianceList(): ng.resource.IResourceClass<interfaces.compliance.IComplianceDisplay> {
                return this.$resource<interfaces.compliance.IComplianceDisplay>(this.ENV.DSP_URL + "ConsignmentTemplate/GetComplianceList", {
                    connectSearch: '@connectSearch',
                    numberRecords: '@numberRecords',
                    pageNumber: '@pageNumber',
                    isInbound: '@isInbound'
                }, {
                        query: {
                            method: 'GET',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates },
                            params: {
                                numberRecords: 25,
                                pageNumber: 1,
                            }
                        }
                    });
            }

            changeComplianceStatus(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "ConsignmentTemplate/ChangeComplianceStatus", {
                    transactionId: '@transactionId',
                    nextStatusId: '@nextStatusId',
                    comments: '@comments'
                });
            }

            auditSignOff(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "ConsignmentTemplate/AuditSignOff", {
                    transactionId: '@transactionId',
                    comments: '@comments'
                });
            }

            auditReject(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "ConsignmentTemplate/AuditReject", {
                    transactionId: '@transactionId',
                    comments: '@comments'
                });
            }

            performEndoftheDayTask(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "ConsignmentTemplate/PerformEndoftheDayTask", {
                });
            }


            saveCompliance(transactionId: number): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {

                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "ConsignmentTemplate/SaveCompliance", {
                    transactionId: transactionId
                }, {
                        query: {
                            method: 'POST',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates }
                        }

                    });
            }

            getForConsignmentDropdown(conId: number): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {
                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "ConsignmentTemplate/getForConsignmentDropdown", {
                    conId: conId
                });
            }

            getForTemplateDropdown(IsInbound: boolean): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {
                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "ConsignmentTemplate/GetForTemplateDropdown", {
                    IsInbound: IsInbound
                });
            }

            getConsignmentCompliance(transactionId: number): ng.resource.IResourceClass<interfaces.compliance.IConsignmentCompliance> {
                return this.$resource<interfaces.compliance.IConsignmentCompliance>(this.ENV.DSP_URL + "ConsignmentTemplate/GetConsignmentComplianceDetail",
                    {
                        transactionId: transactionId
                    }, {
                        get: {
                            method: 'GET',
                            isArray: false,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates }
                        }
                    }
                );
            }

            getComplianceStatusHistoryList(transactionId: number): ng.resource.IResourceClass<interfaces.compliance.ConsignmentComplianceStatusHistory> {
                return this.$resource<interfaces.compliance.ConsignmentComplianceStatusHistory>(this.ENV.DSP_URL + "ConsignmentTemplate/GetComplianceStatusHistoryList",
                    {
                        transactionId: transactionId
                    }, {
                        query: {
                            method: 'GET',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates }
                        }
                    }
                );
            }

            getComplianceDashboardMissingDocsSummary(IsInbound: boolean): ng.resource.IResourceClass<interfaces.compliance.IComplianceDashboardMissingDocumentsSummary> {
                
                return this.$resource<interfaces.compliance.IComplianceDashboardMissingDocumentsSummary>(this.ENV.DSP_URL + "ConsignmentTemplate/GetComplianceDashboardMissingDocsSummary",
                    {
                        IsInbound: IsInbound
                    }, {
                        query: {
                            method: 'GET',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates }
                        }
                    }
                );
            }

            getComplianceExcel(params: any): ng.IPromise<void> {
                var pdfDownload = document.createElement("a");
                document.body.appendChild(pdfDownload);

                var url = this.ENV.DSP_URL + 'ConsignmentTemplate/GetComplianceExcel?';

                var searchObject: interfaces.applicationcore.ISearchObject = {
                    filters: [],
                    sorts: []
                }
                searchObject = params.connectSearch;

                url += 'connectSearch=' + btoa(JSON.stringify(searchObject));
                url += '&IsInbound=' + params.isInbound;

                return this.$http({
                    method: 'GET',
                    responseType: 'arraybuffer',
                    url: url,
                }).then((response) => {
                    var filename = response.headers()['x-filename'] || 'download.xlsx';
                    var fileBlob = new Blob([response.data as BlobPart], { type: 'application/octet-stream' });

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
                        window.navigator.msSaveBlob(fileBlob, filename);
                    } else { // for other browsers
                        var fileURL = window.URL.createObjectURL(fileBlob);
                        pdfDownload.href = fileURL;
                        pdfDownload.download = filename;
                        pdfDownload.click();
                        pdfDownload.remove();
                    }

                    this.$timeout(() => {
                        this.generalService.displayMessage("Your download has started.", Enum.EnumMessageType.Success);
                    });
                }).catch((errorResponse) => {
                    var fileBlob = new Blob([errorResponse.data], { type: 'application/json' });
                    var fileURL = window.URL.createObjectURL(fileBlob);
                    const reader = new FileReader();

                    // This fires after the blob has been read/loaded.
                    reader.addEventListener('loadend', (e: ProgressEvent) => {
                        const text = e.target['result'];

                        this.$timeout(() => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>JSON.parse(text));
                        });
                    });

                    // Start reading the blob as text.
                    reader.readAsText(fileBlob);
                });
            }


            getComplianceDashboardMissingDocsDetailExcel(IsInbound: boolean): ng.IPromise<void> {
                var pdfDownload = document.createElement("a");
                document.body.appendChild(pdfDownload);

                var url = this.ENV.DSP_URL + 'ConsignmentTemplate/GetComplianceDashboardMissingDocsDetailExcel?';

                
                url += '&IsInbound=' + IsInbound;

                return this.$http({
                    method: 'GET',
                    responseType: 'arraybuffer',
                    url: url,
                }).then((response) => {
                    var filename = response.headers()['x-filename'] || 'download.xlsx';
                    var fileBlob = new Blob([response.data as BlobPart], { type: 'application/octet-stream' });

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
                        window.navigator.msSaveBlob(fileBlob, filename);
                    } else { // for other browsers
                        var fileURL = window.URL.createObjectURL(fileBlob);
                        pdfDownload.href = fileURL;
                        pdfDownload.download = filename;
                        pdfDownload.click();
                        pdfDownload.remove();
                    }

                    this.$timeout(() => {
                        this.generalService.displayMessage("Your download has started.", Enum.EnumMessageType.Success);
                    });
                }).catch((errorResponse) => {
                    var fileBlob = new Blob([errorResponse.data], { type: 'application/json' });
                    var fileURL = window.URL.createObjectURL(fileBlob);
                    const reader = new FileReader();

                    // This fires after the blob has been read/loaded.
                    reader.addEventListener('loadend', (e: ProgressEvent) => {
                        const text = e.target['result'];

                        this.$timeout(() => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>JSON.parse(text));
                        });
                    });

                    // Start reading the blob as text.
                    reader.readAsText(fileBlob);
                });
            }            

        }
    }
    angular.module("app").service("consignmentTemplateService", services.compliance.consignmentTemplateService);
}